const ALWAYS_HIDE = ['WID', 'TBRQ', 'TBLX', 'CZRQ', 'CZZ', 'CZZXM'];
export const hiddenCols = () => ALWAYS_HIDE.slice();